//import moment from 'moment'
import moment from 'moment-timezone'

export default function(date, timezone) {
    if (!date) {
        return ''
    }
    const d = moment(date)
    if (timezone) {
        d.utcOffset(timezone)
    }
    return d.format('YYYY/MM/DD HH:mm:ss')
}

